module.exports = __webpack_public_path__ + "static/media/arrow-left.f5c23152.svg";